<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <div>
        <v-form
                ref="queryForm"
        >
            <v-row
                    align="center"
                    justify="center"
            >
                <v-col
                        cols="2"
                        xs="4"
                >
                    <z-source-selector label="请选择部门"
                                       v-model="queryRequest.deptId"
                                       :source="'DeptSelector'">
                    </z-source-selector>
                </v-col>
                <v-col
                        cols="2"
                        xs="4">
                    <z-source-selector label="请选择角色"
                                       v-model="queryRequest.roleId"
                                       source="RoleSelector">
                    </z-source-selector>
                </v-col>
                <v-col
                        cols="2"
                        xs="4"
                >
                    <v-text-field
                            clearable
                            v-model="queryRequest.acctName"
                            label="姓名"
                            single-line
                    ></v-text-field>
                </v-col>

                <v-col
                        cols="2"
                        xs="4"
                >
                    <v-text-field
                            clearable
                            v-model="queryRequest.cellPhone"
                            label="手机号"
                            single-line
                    ></v-text-field>
                </v-col>

                <v-col
                        cols="2"
                        xs="4"
                >
                    <v-btn
                            color="primary"
                            :loading="loading"
                            @click="handleQuery"
                    >
                        搜索
                        <v-icon right>mdi-magnify</v-icon>
                    </v-btn>
                    <v-btn
                            color="primary"
                            class="ma-2"
                            @click="resetQuery"
                    >
                        <v-icon>mdi-refresh</v-icon>
                    </v-btn>
                </v-col>

            </v-row>
        </v-form>
        <v-row class="d-flex justify-center">
            <v-col
                    :sm="10"
                    :xs="12"
                    cols="8">
                <v-data-table
                        :headers="headers"
                        :items="list"
                        :options.sync="options"
                        :server-items-length="total"
                        :loading="loading"
                        :search="search"
                >
                    <template v-slot:top>
                        <v-toolbar height="40" flat>
                            <v-spacer></v-spacer>
                            <v-dialog v-model="dialog" max-width="500px">
                                <template v-slot:activator="{ on }">
                                    <v-btn small color="primary" v-on="on">添加
                                        <v-icon small>mdi-plus</v-icon>
                                    </v-btn>
                                </template>
                                <v-card>
                                    <v-card-title>
                                        <span class="headline">添加用户</span>
                                    </v-card-title>

                                    <v-card-text>
                                        <v-container>
                                            <v-form ref="hospUserAddForm" v-model="hospUserAddFormValid"
                                            >
                                                <v-row align="center">
                                                    <v-col cols="12">
                                                        <v-text-field v-model="newItem.cellPhone"
                                                                      label="请输入手机号">
                                                        </v-text-field>
                                                    </v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col cols="12">
                                                        <z-source-selector label="请选择部门"
                                                                           v-model="newItem.deptId"
                                                                           :rules="[v => !!v || '部门为必选项']"
                                                                           :source="'DeptSelector'">
                                                        </z-source-selector>
                                                    </v-col>
                                                </v-row>
                                                <v-row align="center">
                                                    <v-col cols="12">
                                                        <z-source-selector label="请选择角色"
                                                                           v-model="newItem.roleId"
                                                                           :rules="[v => !!v || '角色为必选项']"
                                                                           source="RoleSelector">
                                                        </z-source-selector>
                                                    </v-col>
                                                </v-row>
                                            </v-form>
                                        </v-container>
                                    </v-card-text>

                                    <v-card-actions>
                                        <v-spacer></v-spacer>
                                        <v-btn color="blue darken-1" text @click="dialog = false">关闭</v-btn>
                                        <v-btn color="blue darken-1" :loading="newItemCommitLoading"
                                               :disabled="!hospUserAddFormValid" text
                                               @click="addCommit">提交
                                        </v-btn>
                                    </v-card-actions>
                                </v-card>
                            </v-dialog>
                        </v-toolbar>
                    </template>
                    <template v-slot:item.actions="{ item }">
                        <!--<v-icon-->
                        <!--small-->
                        <!--class="mr-4"-->
                        <!--@click="editItem(item)"-->
                        <!--&gt;-->
                        <!--mdi-pencil-->
                        <!--</v-icon>-->
                        <v-btn small color="primary" @click="handleRoleChange(item)">变更角色
                        </v-btn>
                        　&nbsp;　&nbsp;　&nbsp;
                        <v-btn small color="primary" @click="handleDelete(item)">用户删除
                        </v-btn>
                    </template>


                </v-data-table>
            </v-col>
        </v-row>

        <v-dialog v-model="changeRoleDialog" max-width="500px">
            <v-card>
                <v-card-title>
                    <span class="headline">角色变更</span>
                </v-card-title>

                <v-card-text>
                    <v-container>

                        <z-source-selector label="角色" v-model="changeRoleRequest.roleId"
                                           source="RoleSelector"></z-source-selector>
                    </v-container>
                </v-card-text>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="blue darken-1" text @click="changeRoleDialog = false">关闭</v-btn>
                    <v-btn color="blue darken-1"
                           text
                           @click="roleChange()">提交
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog
                v-model="deleteDialog"
                width="500"
        >
            <v-card>
                <v-card-title>
                    <span>请确认是否删除用户:{{deleteItem.acctName}}</span>
                </v-card-title>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" text @click="deleteDialog = false">取消</v-btn>
                    <v-btn
                            color="error"
                            text
                            @click="deleteCommit"
                    >
                        删除
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-snackbar
                top
                v-model="snackbar"
        >
            {{ snackbarText }}

        </v-snackbar>

        <z-notify ref="notify" ></z-notify>

    </div>
</template>

<script>
  import {queryRequest, hospModelAcctAdd, deleteAcct, hospUserInfoQuery, changeRole} from '@/api/acct'

  export default {
    name: "UserManagement",
    data() {
      return {
        snackbar: false,
        snackbarText: '',
        hospAddStep: 0,  //0 查询手机用户 ,1 回显用户，选择公司后提交
        dialog: false,
        changeRoleDialog: false,
        updateDialog: false,
        search: '',
        total: 0,
        list: [],
        loading: false,
        options: {},
        headers: [
          {text: '姓名', value: 'acctName', sortable: false},
          {text: '手机号', value: 'cellPhone', sortable: false},
          // {text: '状态', value: 'stateDesc', sortable: false},
          {text: '角色', value: 'roleName', sortable: false},
          {text: '部门', value: 'dept', sortable: false},
          {text: '机构', value: 'institution', sortable: false},
          // {text: '创建时间', value: 'createDateTime'},
          {text: '操作', value: 'actions', sortable: false},

        ],
        hospUserRequest: {
          acctNo: ''
        },
        hospUserRequestLoading: false,
        queryRequest: {
          id: '',
          deptId:'',
          roleId:'',
          cellPhone: "",
          acctName: "",
          sortInfo: {
            sortBy: [],
            sortDesc: []
          },
          pagedQueryInfo: {
            index: 1,
            pageSize: 10
          }
        },
        changeRoleRequest: {
          acctId: '',
          roleId: '',
        },
        newItem: {
          cellPhone: '',
          roleId: '',
          deptId: '',
          institutionId: '',
        },
        roleChangeItem: {
          acctId: '',
          roleId: '',
        },
        hospUserAddFormValid: false,
        newItemCommitLoading: false,
        hospUerInfo: {
          cellPhone: '',
          acctName: '',
          remark: '',
          compName: '',
          id: '',
          hospNameList: []
        },
        editedItem: {},
        deleteDialog: false,
        deleteItem: {
          acctName: ''
        }
      }
    },
    watch: {
      options: {
        handler(val) {
          console.log(val)
          if (val.itemsPerPage == -1) {
            this.queryRequest.pagedQueryInfo.index = 1
            this.queryRequest.pagedQueryInfo.pageSize = 999999
          } else {
            this.queryRequest.pagedQueryInfo.index = val.page
            this.queryRequest.pagedQueryInfo.pageSize = val.itemsPerPage
          }
          this.queryRequest.sortInfo.sortBy = val.sortBy
          this.queryRequest.sortInfo.sortDesc = val.sortDesc
          this.handleQuery()
        }
      }
    },
    methods: {
      handleQuery() {
        this.loading = true
        queryRequest(this.queryRequest).then(res => {
          this.list = res.list
          this.total = res.total
          this.loading = false
        }).catch(err => {
          this.loading = false
        })
      },
      resetQuery() {
        this.$refs.queryForm.reset();
        this.handleQuery();
      },
      editItem() {

      },
      handleDelete(item) {
        this.deleteItem = item
        this.deleteDialog = true
      },
      hospUserQuery() {
        this.hospUserRequestLoading = true
        hospUserInfoQuery(this.hospUserRequest).then(res => {
          if (res.noUser) {
            this.snackbarText = "无此用户"
            this.snackbar = true
          } else {
            this.hospUerInfo = res
            this.newItem = res
            this.newItem.hospAcctId = this.hospUerInfo.id
            this.hospAddStep = 1
          }
          this.hospUserRequestLoading = false
        }).catch(err => {
          this.hospUserRequestLoading = false
        })
      },
      handleRoleChange(item) {
        this.roleChangeItem = item
        this.changeRoleDialog = true
      },
      roleChange() {
        this.changeRoleRequest.acctId = this.roleChangeItem.id;
        changeRole(this.changeRoleRequest).then(res => {
          this.changeRoleDialog = false;
          this.handleQuery();
          this.$refs.notify.show("角色修改成功", {timeout: 1000, color: 'success'});
        }).catch(err => {

        })
      },
      addCommit() {
        if (this.hospUserAddFormValid) {
          this.newItemCommitLoading = true;
          hospModelAcctAdd(this.newItem).then(res => {
            this.newItemCommitLoading = false;
            this.dialog = false;
            this.hospAddStep = 0;
            this.$refs.notify.show("用户添加成功", {timeout: 1000, color: 'success'});
            this.handleQuery();
            Object.assign(this.newItem, this.$options.data().newItem);
            Object.assign(this.hospUerInfo, this.$options.data().hospUerInfo);
          }).catch(err => {
            this.newItemCommitLoading = false
          })
        }
      },
      deleteCommit() {
        deleteAcct(this.deleteItem.id).then(res => {
          this.deleteDialog = false
          this.snackbarText = "删除成功"
          this.snackbar = true
          this.handleQuery()
        }).catch(err => console.error(err))
      }
    }
  }
</script>

<style scoped>

</style>